<template>
  <div class="image-background">
    <div class="image" :style="`background-image: url(${src})`"></div>
  </div>
</template>

<script>
export default {
  name: "ImageBackground",
  props: {
    src: String
  }
};
</script>

<style lang="scss">
.image-background {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  .image {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>